import km from 'keymirror'
import _ from 'underscore'

export default _.extend({}, km({
  TOPIC_GET_LIST_START: null,
  TOPIC_GET_LIST_SUCCESS: null,
  TOPIC_GET_LIST_ERROR: null,

  TOPIC_GET_LIST_MORE_START: null,
  TOPIC_GET_LIST_MORE_SUCCESS: null,
  TOPIC_GET_LIST_MORE_ERROR: null,

  TOPIC_BILLBOARDS_GET_LIST_START: null,
  TOPIC_BILLBOARDS_GET_LIST_SUCCESS: null,
  TOPIC_BILLBOARDS_GET_LIST_ERROR: null,

  TOPIC_ACTIVITY_OUT: null

}))
